import VueVirtualScroller from 'vue-virtual-scroller';

export default defineNuxtPlugin((nuxtApp) => {
  import('vue-virtual-scroller/dist/vue-virtual-scroller.css');
  nuxtApp.vueApp.use(VueVirtualScroller);
});
